'use client';

import { Stack, Text } from '@chakra-ui/react';
import React from 'react';

import type { JobIndustryStep } from '@/modules/authentication/view-model';
import { useIndustryCollections, useIndustryFormWatch } from '@/modules/shared';

import { Form } from '@packages/hook-form-wrapper';

export const JobIndustry = () => {
	const {
		industryId,

		industry,
		subIndustry,
	} = useIndustryFormWatch<JobIndustryStep>();
	const {
		industryCollection,
		subIndustryCollection,
	} = useIndustryCollections(industryId);

	return (
		<Stack gap="sm">
			<Text color="primary.100" textStyle="bodyBold">
				{/* {t('choices', { index: index + 1 })} */}
			</Text>
			<Stack gap="md">
				<Form.SelectInput
					collection={industryCollection}
					label="Industry"
					name={industry.name}
				/>
				<Form.SelectInput
					collection={subIndustryCollection}
					disabled={subIndustry.disabled}
					label="Sub Industry"
					name={subIndustry.name}
				/>
			</Stack>
		</Stack>
	);
};
